import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { moreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { commentsOpen } from '../annotations/CommentCommands';
import { tagsAddNew } from '../annotations/TaggingCommands';
import { AssignmentCreateWidget } from '../assignment/TaskCreateWidget';
import { jiraCreateIssuesFrom } from '../atlassian/AtlassianCommands';
import { connectorBunch, connectorCreateFromSelection, connectorSpread } from '../connector/ConnectorCommands';
import { topicCreate } from '../topics/TopicCommands';
import { DisabledColorWidget } from './DisabledColorWidget';
import { Sticky } from './Sticky';

export const stickyPropertyLayout = LockablePropertyStripLayout<Sticky>((d, s, o, w, a) => {
    const connectors = a.map(x => x.relations('attached').length >= 2).find(x => !!x);
    const hasAutoColor = !!a.get('autoColor', { ifVarying: 'true' });

    return [
        hasAutoColor ? (
            w.createInline({
                ui: DisabledColorWidget
            })
        ) : (
            w.createColorSelector({
                value: a.get('background'),
                text: 'Sticky Color',
                onSelect() {
                    o.update(u => {
                        u.rolling(a.keyFor('background'));
                        a.set('background', this.value!);
                    });
                }
            })
        ),
        w.createDivide(),
        w.createButton({
            image: 'deqo://icons/d2/connector',
            text: 'Connect To...',
            onAction() {
                d(connectorCreateFromSelection);
            }
        }),
        ...(!!connectors ? [
            w.createButton({
                image: 'deqo://icons/d2/connector-bunch',
                text: 'Connector Bunch',
                onAction() {
                    d(connectorBunch);
                }
            }),
            w.createButton({
                image: 'deqo://icons/d2/connector-spread',
                text: 'Connector Spread',
                onAction() {
                    d(connectorSpread);
                }
            }),
        ] : []),
        ...(a.count === 1 ? [
            w.createButton({
                image: 'deqo://icons/d2/comment-small',
                text: 'Add Comment',
                onAction() {
                    d(commentsOpen, [a.get('id'), true]);
                }
            }),
            w.createButton({
                image: 'deqo://icons/hero/tag',
                text: 'Add Tag',
                onAction() {
                    d(tagsAddNew, [a.get('id')]);
                }
            }),
        ] : [
            w.createButton({
                image: 'deqo://icons/deqo/group',
                text: 'Group Under Topic',
                onAction() {
                    d(topicCreate, [a.map(x => x.id)]);
                }
            }),
        ]),
        w.createPopout({
            name: 'assignTo',
            ui: AssignmentCreateWidget,
            value: a.get('id'),
            image: 'deqo://icons/dash/actions@[1.2,1.2,0]',
            text: 'Assign Action To...',
        }),
        w.createButton({
            image: 'deqo://icons/d2/jira',
            text: 'Create Jira Issues',
            onAction() {
                d(jiraCreateIssuesFrom);
            }
        }),
        w.createDivide(),
        // w.createButton({
        //     image: 'deqo://icons/d2/flex',
        //     text: 'Layout',
        //     onAction() {
        //         d(flexLayoutConfigure);
        //     }
        // }),
        w.createDivide(),
        ...moreLayout(d, s, o, w, a),
    ];
});
